import { render, staticRenderFns } from "./User_Agreement.vue?vue&type=template&id=008de592&scoped=true"
import script from "./User_Agreement.vue?vue&type=script&lang=js"
export * from "./User_Agreement.vue?vue&type=script&lang=js"
import style0 from "./User_Agreement.vue?vue&type=style&index=0&id=008de592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008de592",
  null
  
)

export default component.exports